import Fuse from "fuse.js";
import { getBubbleContent } from "./getBubbleContent";
import { getLocationSearchMapCpkConfig } from "./getLocationSearchMapCpkConfig";
import { FranchiseDetail } from "./models/FranchiseDetail";
import { LatLng } from "./models/LatLng";
import { LocationSearchMapCpkConfig } from "./models/LocationSearchMapCpkConfig";
import { MapUI } from "./models/MapUI";
import { printLocationBar, printLocationBars } from "./printLocationBars";
import { replaceInfoBubbleCloseIcon } from "./replaceInfoBubbleCloseIcon";
import { checkDomain, getBrandDetailsFromBrandJson, getFranchiseDetails, isISNFlow, rearrangeCanadaFirst, updateFranchiseDataWithCrownpeakData } from "../util/share";
import { apiConfig } from "../config/apiConfig";
import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { Cluster } from "./Cluster";
import { REGEX } from "../constants/regex";

export class ResultsList
{
    
    franchiseDetails: FranchiseDetail[];
    currFranchiseDetails: FranchiseDetail[];
    cpkConfig: LocationSearchMapCpkConfig;
    fuseOptions: any;
    fuseObj: any;
    pinnedWeblocationId: number = -1;
    mapUi: MapUI;
    activeInfoBubble!: H.ui.InfoBubble;
    cluster: Cluster | undefined;
    constructor(mapUi: MapUI, franchiseDetails: FranchiseDetail[], cluster?: Cluster)
    {
        this.franchiseDetails = franchiseDetails;
        this.currFranchiseDetails = franchiseDetails;
        const cpkConfig = getLocationSearchMapCpkConfig();
        this.cpkConfig = cpkConfig;
        this.cluster = cluster;
       // this.updateListView();
        this.fuseOptions = {
            includeScore: true,
            // Search in `doingBusinessAs` in array
            keys: ['doingBusinessAs'],
            threshold: 0.2
        };
        this.fuseObj = new Fuse(this.franchiseDetails, this.fuseOptions);
        this.mapUi = mapUi;
        
    }

    reorderLocationsForCA() {
        this.updateListView(true);
    }

    filterByCountry(country: string) {
        if (country === 'USA' || country === 'CAN') {
            this.currFranchiseDetails = this.franchiseDetails.filter(f => f.country === country);
        } else {
            this.currFranchiseDetails = this.franchiseDetails;
        }
        this.updateListView();
    }

    async filterResults(bbox: H.geo.Rect, shouldReorderForCA: boolean = false)
    {
        this.currFranchiseDetails = [];
        const locationData = sessionStorage.getItem("nearbyLocations");
        if(locationData){
            const obj = JSON.parse(locationData);
            if(obj.containingData){
                console.log(`Displaying results within limit of ${obj.franchiseLimit} ${obj.units} distance`);
                this.currFranchiseDetails = obj.resultData;
                const marker = this.getMarkerFromMap();
                if (marker) {
                    const markerGeometry = marker.getGeometry() as H.geo.Point;
                    if (markerGeometry) {
                        this.sortCurrentListByDistanceToPin(markerGeometry);
                    }
                }
            }else{
                this.currFranchiseDetails = [];
            }
            this.updateListView(shouldReorderForCA);
            sessionStorage.removeItem("nearbyLocations");
        }
        else {
            // hidden input field
            const servicedLocationInput = document.getElementById('serviced-location') as HTMLInputElement;
            // Check if the element exists and its value is "show-serviced-location"
            const isFilterFlagValid = servicedLocationInput && servicedLocationInput?.value === 'show-serviced-location';
            const locationSearchInput = document.getElementById('location-search') as HTMLInputElement;
            const searchQuery = locationSearchInput?.value.trim();
            const isCaDomain = checkDomain() === 'ca';
            const zipPattern = isCaDomain ? REGEX.caSendZip : REGEX.sendZip;
            const isInvalidZip = locationSearchInput.value !== '' && !zipPattern.test(locationSearchInput.value.trim());
            if (isFilterFlagValid && !isInvalidZip && locationSearchInput.value !== '') {
                await this.handleSearchQuery(searchQuery, bbox );
            }
            else {
                this.filterFranchisesByBbox(bbox);
            }
                this.updateListView(shouldReorderForCA);
        }
        // Update cluster markers to show only current filtered results
        this.updateClusterMarkers();
    }

    filterFranchisesByBbox(bbox: H.geo.Rect) {
          for (let i = 0; i < this.franchiseDetails.length; i++)
            {
                if (bbox.containsLatLng(this.franchiseDetails[i].latitude, this.franchiseDetails[i].longitude) ||
                this.pinnedWeblocationId === this.franchiseDetails[i].franchiseWebLocationId)
                {
                    this.currFranchiseDetails.push(this.franchiseDetails[i]);
                }            
            }
    }

    // Update cluster markers to show only current filtered results
    updateClusterMarkers() {
        if (this.cluster) {
            this.cluster.updateClustering(this.currFranchiseDetails);
        }
    }

    async handleSearchQuery(searchQuery: string, bbox: H.geo.Rect) {
            try {
                const franchiseDetails1 = await getFranchiseDetails(searchQuery, false);
                if (franchiseDetails1 && franchiseDetails1?.length > 0) {
                    // Match the franchiseWebLocationId from API result with this.franchiseDetails
                    const apiWebLocationId = franchiseDetails1[0].franchiseWebLocationId;
                    // Find matching franchise in this.franchiseDetails by franchiseWebLocationId
                    const matchedFranchise = this.franchiseDetails.find(item =>
                        item.franchiseWebLocationId === apiWebLocationId
                    );

                    if (matchedFranchise) {
                        this.currFranchiseDetails.push(matchedFranchise);
                    }
                    else {
                        this.filterFranchisesByBbox(bbox);
                    }
                }
            } catch (error) {
                console.warn('Error fetching franchise details:', error);
            }
           }

    async updateListView (shouldReorderForCA: boolean = false)
    {
        const locationList = document.querySelector('.location-list') as HTMLElement;
        const sessionBrandData = sessionStorage.getItem('brandDetails');
        const brandData = sessionBrandData ? JSON.parse(sessionBrandData) : {};  


        if(locationList){
            locationList.innerHTML = "";
        }
        // If in Brand.json Corownpeak URL is true then overwriting the cuurentFranchiseDetails with the matched weblocationDetails crownpeak URL data 

        if(brandData?.include_crownpeakURL){
            if(!window.crownpeakWeblocationsDetails){
                let crownpeakUrlDetails:any = null;
                const crownpeakURL = apiConfig.CROWNPEAK_WEBLOCATION_URL;
                crownpeakUrlDetails = await getCachedAPIResponse(crownpeakURL, 60, false);
                window.crownpeakWeblocationsDetails = crownpeakUrlDetails;
            }
            const updatedFranchiseData:any = updateFranchiseDataWithCrownpeakData(this.currFranchiseDetails);
            if(updatedFranchiseData){
                this.currFranchiseDetails = updatedFranchiseData;
            }
        }

        if (shouldReorderForCA) {
            this.currFranchiseDetails = rearrangeCanadaFirst(this.currFranchiseDetails);
        }

        locationList?.insertAdjacentHTML('beforeend', '<li class="location-item"></li>');
          try {
            const locationSearchInput = document.getElementById('location-search') as HTMLInputElement;
            const searchQuery = locationSearchInput?.value.trim();
            if (searchQuery) {
               await this.servedZipcodesSearch(searchQuery);
            }
        } catch (error) {
            console.error('Error occurred while searching served zip codes:', error);
        }
        const locationBars: any = await printLocationBars(this.currFranchiseDetails, this.cpkConfig, this.pinnedWeblocationId,brandData);
        // locationList?.appendChild(locationBars);
        if(locationList)
        locationList.innerHTML = locationBars;
        const locationFoundText = document.querySelector('.location-total-text') as HTMLElement;
        if(locationFoundText){
            if (this.currFranchiseDetails.length > 0 )
            {
                locationFoundText.innerHTML = `${this.currFranchiseDetails.length} locations found`;
                locationList.style.display = "block";
            }
            else
            {
                const noLosAvailableMsg = document.getElementById('no-locs-available-msg') as HTMLElement;  
                locationFoundText.innerHTML = noLosAvailableMsg?.innerHTML;
                locationFoundText.style.lineHeight = "normal";
                locationFoundText.style.display = "block";
                locationList.style.display = "none";
            }
        }
            this.addClickEventListenerToTitles();
    }

    resetList()
    {
        this.currFranchiseDetails = this.franchiseDetails;
        const searchBox = document.getElementById('location-search') as HTMLInputElement;

        const viewModel =  this.mapUi?.map?.getViewModel();
        const lookAtData = viewModel?.getLookAtData();
        const bounds = lookAtData?.bounds;

        if (bounds) {
            this.filterResults(bounds.getBoundingBox());
        }
        // if(searchBox.value != ''){
            // this.updateListView();
        // }
        
    }

    searchByDBAName(searchQuery: string)
    {        
        const result = this.fuseObj.search(searchQuery);
        return result;
    }

    getMarkerFromMap(): H.map.Marker | null {
        if (!this.mapUi?.map) return null;
        
        const objects = this.mapUi.map.getObjects();
        const marker = objects.find(obj => obj instanceof H.map.Marker);
        return marker as H.map.Marker || null;
    }

    sortCurrentListByDistanceToPin(pin: LatLng){
        //console.log('before sorting: ', this.debugDisplayDistanceFromPin(pin));
        const pointPin = new H.geo.Point(pin.lat, pin.lng);
        this.currFranchiseDetails.sort((a: FranchiseDetail, b: FranchiseDetail) => {
            const pointA = new H.geo.Point(a.latitude, a.longitude);
            const pointB = new H.geo.Point(b.latitude, b.longitude);
            const dist1 = pointPin.distance(pointA);
            const dist2 = pointPin.distance(pointB);
            return dist1-dist2;
        });
        //console.log('after sorting: ', this.debugDisplayDistanceFromPin(pin));
    }
    
    debugDisplayDistanceFromPin(pin: LatLng){
        const pointPin = new H.geo.Point(pin.lat, pin.lng);
        const arr = [];
        for(let i=0; i<this.currFranchiseDetails.length; ++i)
        {
            const point = new H.geo.Point(this.currFranchiseDetails[i].latitude, this.currFranchiseDetails[i].longitude);
            const dist = pointPin.distance(point);
            arr.push({
                name: this.currFranchiseDetails[i].doingBusinessAs,
                dist: dist
            });
        }
        return arr;
    }

    pinFirstResult(){
            this.pinnedWeblocationId = this.currFranchiseDetails[0].franchiseWebLocationId;   
    }

    unpinFirstResult(){
        this.pinnedWeblocationId = -1;
    }

    addClickEventListenerToTitles(){
        // event when title on the list is clicked
        const locationBarTitles = document.getElementsByClassName('location-heading');
                
        for (const element of locationBarTitles) {
            const el = element as HTMLElement;
            if(el) {
                el.addEventListener('click', event => {
                    const nextSibling = el.parentElement?.nextSibling;
                    if (nextSibling instanceof HTMLElement) {
                        const weblocationId: number = +(nextSibling.nextSibling as HTMLInputElement)?.value;
                    const franchiseDetail = this.franchiseDetails.find(f=>f.franchiseWebLocationId === weblocationId);
                    if(franchiseDetail) {
                        this.locationBarClick(franchiseDetail);
                    }  
                    let regexp:any = /android|iphone|kindle|ipad/i;
                    let Devicedetails:any = navigator.userAgent;
                    let isMobileDevice = regexp.test(Devicedetails); 
                    }              
                });
            }        
        }
        const conceptCode = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        if (conceptCode.toLocaleLowerCase() === "25") {
            const bookInspectionButton = document.querySelectorAll('[id="requestEstimate"]');
            for (const element of bookInspectionButton) {
                element.addEventListener('click', async (event: any) => {
                    event.preventDefault();
                    const locationItem = (event.currentTarget as HTMLElement).closest("li.location-item");
                    if (locationItem) {
                        const locationText = locationItem.querySelector(".location-main")?.textContent?.trim() ?? "";
                        const zipRegex = /\b(?:\d{5}(?:-\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d)\b/;
                        const zipMatch = zipRegex.exec(locationText);
                        if (zipMatch) {
                            const zipcode = zipMatch[0];
                            sessionStorage.setItem('sAddressParam', zipcode);
                            sessionStorage.setItem('locationLeadFlow', 'true');
                            let franchiseDetail = locationItem.querySelector(".franchise-details");
                            franchiseDetail = franchiseDetail ? JSON.parse((franchiseDetail as HTMLElement)?.dataset.json!) : null;
                            isISNFlow(franchiseDetail,zipcode,event.currentTarget.href);
                        } else {
                            console.log("ZIP code not found in location text.");
                        }
                    } else {
                        console.log('location-item container not found');
                    }
                });
            }
        }
    }

    locationBarClick(franchiseDetail: FranchiseDetail){
        //console.log('location bar clicked');    
        
        if(this.activeInfoBubble) {
            this.mapUi.ui.removeBubble(this.activeInfoBubble);
        }    
        (async () => {
        this.activeInfoBubble = new H.ui.InfoBubble({lat: franchiseDetail.latitude, lng: franchiseDetail.longitude}, {
            content: await getBubbleContent(franchiseDetail)
        });
        })();
        // show info bubble
        this.mapUi.ui.addBubble(this.activeInfoBubble);
        this.mapUi.map.setCenter({lat:franchiseDetail.latitude, lng: franchiseDetail.longitude});
        this.activeInfoBubble.open();   
        replaceInfoBubbleCloseIcon();     
    }

   async updateLocationBar(franchiseDetail: FranchiseDetail)
    {
     
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode)

        const updatedResultItemView = await printLocationBar(franchiseDetail, this.cpkConfig,brandData);
        const locationBar = this.findLocationBar(franchiseDetail.franchiseWebLocationId);
        if(locationBar)
        {
            locationBar.innerHTML = updatedResultItemView;
            locationBar.addEventListener('click', event => {
                this.locationBarClick(franchiseDetail);
            })
        }
        
    }
    
    findLocationBar = (webLocationId: number): Element | null => 
    {
        let children = document.querySelectorAll('.location-list .weblocation-id');
        const index = this.currFranchiseDetails.findIndex(x => x.franchiseWebLocationId === webLocationId);
        if(index > -1)
        {
            return children[index].parentNode as Element;
        }
        return null;
    }

    servedZipcodesSearch(searchQuery: string) {
        return new Promise<void>((resolve) => {
            getFranchiseDetails(searchQuery, false).then(franchiseDetails => {
                if (franchiseDetails && franchiseDetails.length > 0) {
                    let franchiseWebLocationId = franchiseDetails[0].franchiseWebLocationId;
                    let matchedItems = this.currFranchiseDetails.filter(f => f.franchiseWebLocationId === franchiseWebLocationId);
                    if (matchedItems.length > 0) {
                    this.currFranchiseDetails = matchedItems.concat(this.currFranchiseDetails.filter(f => f.franchiseWebLocationId !== franchiseWebLocationId));
                    if(this.currFranchiseDetails.length > 0){
                        this.pinnedWeblocationId = this.currFranchiseDetails[0].franchiseWebLocationId;
                    }
                }
            }
            resolve();
        }).catch(error => {
            console.error('Error fetching franchise details:', error);
            resolve();
        });
    });
    }
}